import { render, staticRenderFns } from "./Shortcoming.vue?vue&type=template&id=08855a7b"
import script from "./Shortcoming.vue?vue&type=script&lang=js"
export * from "./Shortcoming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports